import { DevicesActionTypes } from '../types';
import { SAVE_DEVICES } from '../constants/actionTypes';

export const saveDevices = (devices: any[] = []): DevicesActionTypes => ({
  type: SAVE_DEVICES,
  payload: devices,
});

